/* Temporary Astute/Rainbow carton policy. Restricted to the four reviewed products. */
(function () {
  'use strict';
  if (window.simplovaAllseatingCartonGuard) return;
  window.simplovaAllseatingCartonGuard = true;
  var ids = ['14727945421165', '14779765752173', '14816351879533', '14816368132461'];
  var busy = false;
  var product = document.body.getAttribute('data-simplova-carton-product') === 'true';
  var active = window.simplovaAllseatingCartonCart === true || product;
  var message = 'Single-chair Astute and Rainbow orders are available by quote. Online checkout requires at least two chairs per configuration. Open the product and use Add to Quote for a single chair or mixed single-chair configurations.';
  var root = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
  function invalid(cart) {
    return (cart.items || []).filter(function (item) {
      return ids.indexOf(String(item.product_id)) !== -1 && Number(item.quantity) < 2;
    });
  }
  function getCart() {
    return fetch(root + 'cart.js', {credentials: 'same-origin', headers: {'Accept': 'application/json'}})
      .then(function (response) { if (!response.ok) throw new Error('Unable to check cart'); return response.json(); });
  }
  function show(rows) {
    var old = document.getElementById('simplova-allseating-carton-notice');
    if (old) old.remove();
    var notice = document.createElement('div');
    notice.id = 'simplova-allseating-carton-notice';
    notice.setAttribute('role', 'alert');
    notice.setAttribute('tabindex', '-1');
    notice.style.cssText = 'max-width:960px;margin:20px auto;padding:16px;background:#fff3e4;border-left:3px solid #c65b13;font-size:14px;line-height:1.5;color:#222';
    var p = document.createElement('p');p.textContent = message;notice.appendChild(p);
    rows.forEach(function (item) {
      var p = document.createElement('p');var a = document.createElement('a');
      a.href = item.url;a.textContent = item.product_title || item.title;p.appendChild(a);notice.appendChild(p);
    });
    var host = document.querySelector('main') || document.body;
    host.prepend(notice);notice.focus();notice.scrollIntoView({block: 'center'});
  }
  function protect(event, target) {
    event.preventDefault();event.stopImmediatePropagation();
    if (busy) return;
    busy = true;
    getCart().then(function (cart) {
      var rows = invalid(cart);
      if (rows.length) show(rows);
      else window.location.assign(root + 'checkout');
    }).catch(function () { window.alert('Please refresh your cart before continuing to checkout.'); })
      .finally(function () {busy = false;});
  }
  document.addEventListener('click', function (event) {
    var element = event.target && event.target.closest ? event.target : null;
    if (!element) return;
    var target = element.closest('[name="checkout"],a[href="/checkout"],a[href^="/checkout?"],a[href*="/checkouts/"],button[data-checkout]');
    if (target && active) protect(event, target);
  }, true);
  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form || !form.matches || !form.matches('form[action*="/cart"]')) return;
    if (active && ((event.submitter && event.submitter.name === 'checkout') || /\/checkout(?:\?|$)/.test(form.action))) protect(event, form);
  }, true);
  // Keep wallet shortcuts from skipping the cart review for these products.
  function wallets(cart) {
    var protectedCart = (cart.items || []).some(function (item) {return ids.indexOf(String(item.product_id)) !== -1;});
    active = protectedCart || product;
    var style = document.getElementById('simplova-allseating-wallets');
    if (!style) {style = document.createElement('style');style.id='simplova-allseating-wallets';document.head.appendChild(style);}
    style.textContent = (protectedCart || product) ? '.shopify-payment-button,shopify-buy-it-now-button,.additional-checkout-buttons,[data-shopify="dynamic-checkout-cart"]{display:none!important}' : '';
  }
  getCart().then(wallets).catch(function () {});
  var originalFetch = window.fetch;
  window.fetch = function () {
    var request=arguments[0];
    var url=typeof request==='string'?request:(request && request.url)||'';
    var response=originalFetch.apply(this,arguments);
    if (/\/cart\/(?:add|change|update|clear)(?:\.js)?(?:\?|$)/.test(String(url))) {
      response.then(function(){getCart().then(wallets).catch(function(){});}).catch(function(){});
    }
    return response;
  };
  document.addEventListener('cart:updated', function () {getCart().then(wallets).catch(function () {});});
  if (window.jQuery) window.jQuery(document).on('ajaxComplete.simplovaCarton',function(event,xhr,settings){
    if (/\/cart\/(?:add|change|update|clear)(?:\.js)?(?:\?|$)/.test(String(settings.url))) getCart().then(wallets).catch(function(){});
  });
  if (typeof module !== 'undefined' && module.exports) module.exports = {invalid: invalid};
})();